import Button from '@blocks/Button';
import Form from '@blocks/Form';
import Grid from '@blocks/Grid';
import Sidepanel from "@blocks/Sidepanel";
import { useSidepanelContext } from '@contexts/sidepanel';
import { capitalize, notify } from '@helpers';
import React from 'react';

export default function ResourceAddSidepanel<R extends object>({ resource, label, controller, form: FormInputs }: Modules.Resource.SidepanelOptions<R>) {
    const sidepanel = useSidepanelContext()

    const handleSubmit = async (data: FormData) => {
        sidepanel.close()
        return controller.store(data)
    }

    const handleSuccess = (response: R) => {
        resource.setData(old => {
            if (!old) return
            return [response, ...old]
        })

        notify(`The ${label} was created.`)
    }

    return (
        <Sidepanel heading={`Add: ${capitalize(label)}`}>
            <Form handleSubmit={handleSubmit} handleSuccess={handleSuccess}>
                <Grid>
                    <FormInputs />
                    <Button element="submit">Add</Button>
                </Grid>
            </Form>
        </Sidepanel>
    )
}